import { ModalService } from '@app/plugins/iview-modal-modify/service';
import { ProductsService } from '@autocaller_v2/services/ProductsService';
import ItemForm from '@autocaller_v2/components/modal-products-create-edit-form';
import i18n from '@app/plugins/i18n';

class ProductsModalService extends ModalService {
  constructor() {
    super(ProductsService);
  }

  remove(id, name) {
    return this.$removeItem(id, name, {
      content: i18n.t('autocaller_v2.products.remove', {
        name: `<strong>${name}</strong>`
      })
    });
  }

  create() {
    return this.$open({
      title: i18n.t('autocaller_v2.operators.skills.create'),
      width: this.size.default,
      loading: true,
      render: (h) =>
        h(ItemForm, {
          on: {
            success: (data) => {
              this.$emit('success', data);
              this.modal.remove();
            }
          }
        })
    });
  }

  edit(id, name) {
    return this.$open({
      title: i18n.t('autocaller_v2.operators.skills.edit'),
      width: this.size.default,
      loading: true,
      render: (h) => {
        return h(ItemForm, {
          props: {
            id,
            name
          },

          on: {
            success: (data) => {
              this.$emit('success', data);
              this.modal.remove();
            }
          }
        });
      }
    });
  }
}

const instance = new ProductsModalService();
export { instance as ProductsModalService };
